export default "__VITE_ASSET__xbE3ukIV__"